import { breakpointNames } from '../../../css/breakpoints';
import { objectMap } from '../../../library/object';
export const colorSchemesBoxFontMap = {
  white: 'black',
  whiteFaded: 'black',
  alert100: 'alert400',
  alert200: 'black',
  alert300: 'white',
  alert400: 'white',
  success100: 'success400',
  success200: 'white',
  success300: 'white',
  success400: 'white',
  help100: 'help400',
  help300: 'white',
  help400: 'white',
  error100: 'error300',
  chick100: 'chick400',
  chick300: 'white',
  grey100: 'black',
  grey400: 'white',
  grey100Faded: 'black',
  grey500: 'white',
  grey200Faded: 'black',
  grey300Faded: 'black',
  neutralWarm100: 'black',
  neutralWarm200: 'black',
  neutralWarm300: 'black',
  neutralCold100: 'black',
  primary100: 'black',
  primary200: 'black',
  primary300: 'white',
  primary400: 'white',
  primary500: 'white'
};
export const isColorSchemeBoxProps = cs => typeof cs.schema !== 'undefined';
export const isColorSchemeBoxPropsOutlined = cs => isColorSchemeBoxProps(cs) && isColorSchemeBoxNamesOutlined(cs.schema);
export const isColorSchemeBoxNamesOutlined = s => s.match(/Outlined$/) !== null;
export const isColorSchemeBoxNamesBordable = s => isColorSchemeBoxNamesOutlined(s) || s === 'bgWhite';
export const colorSchemeBoxNamesOutlinedRemover = s => s.replace('Outlined', ''); // cs with Outlined -> bg: white, border: cs, font: cs
// cs without Outlined -> bg: cs, font: white / black / custom

const csPropsToBoxProps = cs => {
  if (cs.schema === 'bgWhite') {
    return {
      backgroundColor: 'white',
      fontColor: 'black',
      // eslint-disable-next-line no-nested-ternary
      border: cs.border ? typeof cs.border === 'string' ? `grey100-${cs.border}` : `grey100-${cs.border.width}-${cs.border.position}` : undefined
    };
  }

  if (isColorSchemeBoxPropsOutlined(cs)) {
    const csClean = colorSchemeBoxNamesOutlinedRemover(cs.schema);
    return {
      backgroundColor: 'white',
      fontColor: csClean,
      // eslint-disable-next-line no-nested-ternary
      border: cs.border ? typeof cs.border === 'string' ? `${csClean}-${cs.border}` : `${csClean}-${cs.border.width}-${cs.border.position}` : undefined
    };
  }

  return {
    backgroundColor: cs.schema,
    fontColor: colorSchemesBoxFontMap[cs.schema]
  };
};

const colorsBoxProps = ['fontColor', 'backgroundColor', 'border'];

const extract = (cscsd, p) => {
  return {
    [p]: breakpointNames.reduce((c, b) => {
      const cscs = cscsd[b];

      if (typeof cscs === 'undefined' || typeof cscs[p] === 'undefined') {
        return c;
      }

      return Object.assign(Object.assign({}, c), {
        [b]: cscs[p]
      });
    }, {})
  };
};

export const resolveColorPropsFromScheme = csProps => {
  if (typeof csProps === 'undefined') {
    return {};
  }

  if (isColorSchemeBoxProps(csProps)) {
    return csPropsToBoxProps(csProps);
  }

  const cscsd = objectMap(csProps, cs => cs ? csPropsToBoxProps(cs) : undefined);
  return colorsBoxProps.reduce((c, p) => Object.assign(Object.assign({}, c), extract(cscsd, p)), {});
};
//# sourceMappingURL=boxColorSchemes.js.map